import { render, staticRenderFns } from "./ztDataTable.vue?vue&type=template&id=66c9ba1a&scoped=true"
import script from "./ztDataTable.vue?vue&type=script&lang=js"
export * from "./ztDataTable.vue?vue&type=script&lang=js"
import style0 from "../../../../styles/components/ztDataTable.css?vue&type=style&index=0&id=66c9ba1a&prod&lang=css&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../../web-empleado/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c9ba1a",
  null
  
)

export default component.exports